import axios from "axios";
import { API_CENTRE } from "./config";
import _o2sService from "./_o2sServices";
import { IFilter } from "../models/filters/filter";
import  IDevicePropertyFilter from "../models/filters/devicePropertyFilter";
import IDevicePropertyForm from "../models/forms/devicePropertyForm";
import IDevicePropertyPDTO from "../models/dtos/devicePropertyPDTO";

/** Logique d'interaction avec les matériels */
export default class DevicePropertyServices extends _o2sService {

    protected static override mainUrl: string = API_CENTRE + "/api/v1/deviceProperties";

    protected static override getUrlFilter<F extends IDevicePropertyFilter>(filter?: F): string {
        let url = super.getUrlFilter(filter as IFilter);
        if ( filter != undefined) 
        {
            if ( filter.deviceId != undefined)
                url += `&DeviceId=${filter.deviceId}`;
        }
        return url;
    }

    protected static override toDTO(obj: IDevicePropertyForm): IDevicePropertyPDTO {
        const dto = super.toDTO(obj) as IDevicePropertyPDTO;
        
        return dto;
    }
}
